"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.settings = void 0;
const host_modules_1 = require("@wix/sdk-runtime/host-modules");
exports.settings = (0, host_modules_1.createHostModule)({
    getTimezone: (host) => () => {
        const timezone = host.essentials?.timezone;
        if (!timezone) {
            throw new Error('Host timezone is not available on the current host. Make sure to use an updated version of the host initialization package.');
        }
        return timezone;
    },
});
